$('[data-fancybox="gallery"]').fancybox({

});
    
    $(document).ready(function(){  
        $('.difference_block').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  arrows:false,
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              }
            ]
        });
        $('.three-block-section-in').slick({
            responsive: [
              {
                breakpoint: 3000,
                settings: "unslick"
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                  arrows:false,
                  slidesToScroll: 1,
                  dots: true,
                }
              }
            ]
        });
      $('.rewards-text-image-in').slick({
            responsive: [
              {
                breakpoint: 3000,
                settings: "unslick"
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                  arrows:false,
                  slidesToScroll: 1,
                  dots: true,
                }
              }
            ]
        });
        $('.vip-tier-in').slick({
            responsive: [
              {
                breakpoint: 3000,
                settings: "unslick"
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                  centerMode:true,
                  centerPadding: '60px',
                  arrows:false,
                  slidesToScroll: 1,
                  dots: true,
                }
              }
            ]
        });
      $('.tab.text-image-link-in').slick({

            responsive: [
              {
                breakpoint: 3000,
                settings: "unslick"
              },
              {
                breakpoint: 1300,
                settings: {
                  slidesToShow: 7,
                  infinite: true,
                  arrows:false,
                  slidesToScroll: 5,
                  dots: true,
                }
              },
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 5,
                  infinite: true,
                  arrows:false,
                  slidesToScroll: 4,
                  dots: true,
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 4,
                  infinite: true,
                  arrows:false,
                  slidesToScroll: 4,
                  dots: true,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  infinite: true,
                  slidesToScroll: 3,
                  dots: true,
                  arrows:false,
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  infinite: true,
                  dots: true,
                  arrows:false,
                  slidesToScroll: 2,
                }
              }
            ]
        });
      $('.wwl-right-box').slick({
            dots: false,
            infinite: true,
            arrows:false,
            speed: 300,
            centerMode:true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        dots: true,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                      centerMode: true,
                        slidesToShow: 1,
                        dots: true,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    $('.featured_articals_block').slick({
            dots: true,
            infinite: true,
            arrows:false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                      centerMode: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });      
      $('.merch-style-slider').slick({
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  dots: true,
                  arrows:false,
                }
              }
            ]
        });
$('.stl-slider').slick({
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
        });

var $status = $('.pagingInfo');
var $slickElement = $('.overview-slider');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text(i + '/' + slick.slideCount);
});

$slickElement.slick({
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        adaptiveHeight: true
      }
    }
  ]
});

var slideCount = $('.overview-slider .slick-slide').length;
if (slideCount <= 1) {
  $slickElement.addClass('slc-dts-hd');
  $('.pagingInfo').hide();
}

      
$('.blog-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  adaptiveHeight: true,
});

      $('.a-pro-lists').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
      responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
    });
      
    $('.review_text').slick({
            dots: true,
            arrows:true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                  arrows:false,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                }
              }
            ]
        });
      $('.pd-slider').slick({
            dots: true,
            arrows:true,
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  dots: false,
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  dots: false,
                  arrows:false,
                }
              }
            ]
        });
         // setTimeout(function(){
         //    $('.junip-product-summary-review-count:contains("")').each(function() {
         //      $(this).html($(this).html().split("").join(""));
         //    });
         //  }, 11000);
      
      });







(function($) {
    $.fn.Popup = function(options) {
        var defaults = $.extend({
            centerPopup: true,
            open: function() {},
            closed: function() {}
        }, options);

        /******************************
        Private Variables
        *******************************/

        var object = $(this);
        var settings = $.extend(defaults, options);

        /******************************
        Public Methods
        *******************************/

        var methods = {
            init: function() {
                return this.each(function() {
                    methods.appendHTML();
                    methods.setEventHandlers();
                    methods.showPopup();
                });
            },

            /******************************
            Append HTML
            *******************************/

            appendHTML: function() {

                // if this has already been added we don't need to add it again
                if ($('.PopupBackground').length === 0) {
                    var background = '<div class="PopupBackground"></div>';
                    $('body').prepend(background);
                }

                if (object.find('.PopupClose').length === 0) {
                    var close = '<div class="PopupClose"><img src="https://cdn.shopify.com/s/files/1/1977/4409/files/close-icon.png?v=1741247287"></div>';
                    object.prepend(close);
                }
            },

            /******************************
            Set Event Handlers
            *******************************/

            setEventHandlers: function() {
                $(".PopupClose, .PopupBackground").on("click", function(event) {
                    methods.hidePopup();
                });
                $(window).on("resize", function(event) {
                    if (settings.centerPopup) {
                        methods.positionPopup();
                    }
                });

            },

            removeEventListners: function() {
                $(".PopupClose, .PopupBackground").off("click");
            },

            showPopup: function() {
                $(".PopupBackground").css({
                    "opacity": "0.7"
                });
                $(".PopupBackground").fadeIn("fast");
                object.fadeIn("slow", function() {
                    settings.open();
                });
                if (settings.centerPopup) {
                    methods.positionPopup();
                }
            },
            hidePopup: function() {
                $(".PopupBackground").fadeOut("fast");
                object.fadeOut("fast", function() {
                    methods.removeEventListners();
                    settings.closed();
                });
            },

            positionPopup: function() {
                var windowWidth = $(window).width();
                var windowHeight = $(window).height();
                var popupWidth = object.width();
                var popupHeight = object.height();

                var topPos = (windowHeight / 2) - (popupHeight / 2);
                var leftPos = (windowWidth / 2) - (popupWidth / 2);
                if (windowWidth < 1025) {
                    var leftPos = (windowWidth / 2) - (popupWidth / 1.9);
                }
                if (windowWidth < 767) {
                    var leftPos = (windowWidth / 2) - (popupWidth / 1.7);
                }
                if (topPos < 30) topPos = 30;

                object.css({
                    "position": "fixed",
                    "top": topPos,
                    "left": leftPos
                });
            },

        };

        if (methods[options]) { // $("#element").pluginName('methodName', 'arg1', 'arg2');
            return methods[options].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof options === 'object' || !options) { // $("#element").pluginName({ option: 1, option:2 });
            return methods.init.apply(this);
        } else {
            $.error('Method "' + method + '" does not exist in popup plugin!');
        }
    };

})(jQuery);







